"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateMinutesOptions = exports.generateHourOptions = exports.extractTimeParts = exports.MAX_MINUTE = exports.MAX_HOUR = void 0;
var _arrays = require("../../../utilities/arrays");
var _strings = require("../../../utilities/strings");
const MAX_HOUR = exports.MAX_HOUR = 23;
const MAX_MINUTE = exports.MAX_MINUTE = 59;
const generateHourOptions = function () {
  let minHour = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let maxHour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_HOUR;
  return (0, _arrays.range)(minHour, maxHour).map(h => {
    return {
      value: h,
      label: (0, _strings.padNumberWithPrefixZero)(h)
    };
  });
};
exports.generateHourOptions = generateHourOptions;
const generateMinutesOptions = function () {
  let minMinute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let maxMinute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_MINUTE;
  let step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return (0, _arrays.range)(0, MAX_MINUTE, step).filter(m => minMinute <= m && m <= maxMinute).map(m => {
    return {
      value: m,
      label: (0, _strings.padNumberWithPrefixZero)(m)
    };
  });
};
exports.generateMinutesOptions = generateMinutesOptions;
const extractTimeParts = time => {
  let hours = -1;
  let minutes = -1;
  if (typeof time === 'string' && time.includes(':')) {
    const timeParts = time.split(':');
    if (timeParts.length === 2) {
      hours = parseInt(timeParts[0]);
      minutes = parseInt(timeParts[1]);
    }
  } else if (typeof time === 'object') {
    hours = time.getHours();
    minutes = time.getMinutes();
  }
  hours = !isNaN(hours) && hours >= 0 ? hours : 0;
  minutes = !isNaN(minutes) && minutes >= 0 ? minutes : 0;
  return {
    hours,
    minutes
  };
};
exports.extractTimeParts = extractTimeParts;